<script setup lang="ts">
import { Button, Hero, Icon } from "@/components/Ui";
import { onDashboard } from "@/helpers/events";

const { t } = useI18n();
</script>
<template>
  <Hero
    :label="$t('hero.affiliate.label')"
    :label-class="$style[`label-${$i18n.locale}`]"
    label-icon="gift"
    :title-class="$style[`root-title`]"
    :class="$style.root"
    class="container"
  >
    <template #title>
      <h1>{{ t("block.heroAffiliate.title") }}</h1>
    </template>
    <p :class="$style[`root-subtitle`]">
      {{ t("block.heroAffiliate.subtitle") }}
    </p>
    <div :class="$style[`card`]">
      <Icon :name="`pst-card-affiliate`" path="cards" />
      <Button
        :title="$t('btn.getReferralLink')"
        :class="$style[`button`]"
        color="orange"
        size="custom"
        @click="
          onDashboard('login_button_click', '/login', {
            'cta type': 'button',
            'cta location': 'Hero:Affiliate',
            'cta text': 'Get referral link',
          })
        "
      />
    </div>
  </Hero>
</template>
<style lang="scss" module>
.root {
  @apply pt-[60px] gap-6;
  &-title {
    @apply font-black text-neutral-800 text-center max-w-[970px] mb-0;
    @apply text-[40px] xs:text-[54px] sm:text-[60px];
    @apply leading-[1.2];
  }

  &-subtitle {
    @apply text-neutral-800 text-[24px] text-center;
  }
}

.card {
  @apply flex flex-col items-center gap-6 w-full max-w-[336px];

  & svg {
    @apply h-full w-full;
  }
}

.button {
  @apply text-[15px] w-full h-12;
}

.label {
  &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
  &-be,
  &-de,
  &-tr,
  &-th,
  &-pl,
  &-hi,
  &-ar,
  &-bn,
  &-ko,
  &-vi,
  &-sw {}
  &-ua,
  &-fr,
  &-it,
  &-es,
  &-ru,
  &-bg,
  &-ja,
  &-pt{
    @apply flex-col text-center px-8 gap-1;
    @screen xs {
      @apply flex-row px-4 py-3 gap-[10px];
    }
  }
}
</style>
